import React, { memo, useCallback, useEffect } from 'react';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './UnlinkCardConfirmModal.css';
import type { UnlinkCardConfirmModalProps } from './UnlinkCardConfirmModal.types';

const BUTTONS = [EButtonType.accept, EButtonType.action];

const defaultRenderHeader = () => 'Без карты подписка не продлится';
const defaultRenderContent = () => {
    return (
        <ul className={styles.list}>
            <li>Пропадут дополнительные гигабайты</li>
            <li>Нельзя будет загружать тяжёлые файлы</li>
            <li>Вернётся реклама в Почте и Облаке</li>
        </ul>
    );
};

const POPUP_ANALYTICS_ACTION = 'modal-stop-delete-card';

export const UnlinkCardConfirmModal = memo<UnlinkCardConfirmModalProps>(
    ({
        actionButtonText = 'Отвязать',
        className,
        dataQAId = 'unlink-card-confirm-modal',
        renderContent = defaultRenderContent,
        renderHeader = defaultRenderHeader,
        sendAnalytics,
        onUnlink,
        onClose,
    }) => {
        useEffect(() => {
            sendPaymentGa({ action: POPUP_ANALYTICS_ACTION, label: 'show' });
            sendAnalytics?.('show');
        }, [sendAnalytics]);

        const handleSuccess = useCallback(() => {
            sendPaymentGa({ action: POPUP_ANALYTICS_ACTION, label: 'continue' });
            sendAnalytics?.('click', 'keep_card');
            onClose?.();
        }, [onClose, sendAnalytics]);

        const handleAction = useCallback(() => {
            sendPaymentGa({ action: POPUP_ANALYTICS_ACTION, label: 'delete' });
            emitAnalyticEvent(AnalyticEventNames.CARD_REMOVE_CONFIRM);
            sendAnalytics?.('click', 'unlink_card');

            onUnlink();
            onClose?.();
        }, [onClose, onUnlink, sendAnalytics]);

        const handleClose = useCallback(() => {
            sendPaymentGa({ action: POPUP_ANALYTICS_ACTION, label: 'close' });
            sendAnalytics?.('close');
            onClose?.();
        }, [onClose, sendAnalytics]);

        return (
            <BaseConfirmDialog
                renderHeader={renderHeader}
                renderContent={renderContent}
                successButtonText="Оставить карту"
                onSuccess={handleSuccess}
                onAction={handleAction}
                actionButtonText={actionButtonText}
                className={className}
                onClose={handleClose}
                dataQAId={dataQAId}
                buttons={BUTTONS}
                buttonTheme="vk"
                isDarkTheme={false}
                size="tiny"
            />
        );
    }
);

UnlinkCardConfirmModal.displayName = 'UnlinkCardConfirmModal';
